module.exports = __webpack_public_path__ + "static/media/call-to-action-bg.7a6c36e8.jpg";